// extracted by mini-css-extract-plugin
module.exports = {"footerInput":"FooterInput_footerInput__3tEF-"};